/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'

import addDays from 'date-fns/add_days'
import addHours from 'date-fns/add_hours'
import addMinutes from 'date-fns/add_minutes'
import addMonths from 'date-fns/add_months'
import addWeeks from 'date-fns/add_weeks'
import differenceInCalendarWeeks from 'date-fns/difference_in_calendar_weeks'
import endOfDay from 'date-fns/end_of_day'
import format from 'date-fns/format'
import getDate from 'date-fns/get_date'
import getDay from 'date-fns/get_day'
import getHours from 'date-fns/get_hours'
import getMinutes from 'date-fns/get_minutes'
import getMonth from 'date-fns/get_month'
import getYear from 'date-fns/get_year'
import isAfter from 'date-fns/is_after'
import isBefore from 'date-fns/is_before'
import isEqual from 'date-fns/is_equal'
import isSameMonth from 'date-fns/is_same_month'
import isValid from 'date-fns/is_valid'
import setDate from 'date-fns/set_date'
import setHours from 'date-fns/set_hours'
import setMinutes from 'date-fns/set_minutes'
import setMonth from 'date-fns/set_month'
import setYear from 'date-fns/set_year'
import startOfDay from 'date-fns/start_of_day'
import startOfMonth from 'date-fns/start_of_month'

import ChevronLeftIcon from '@offerzen/zenicon/ChevronLeftIcon'
import ChevronRightIcon from '@offerzen/zenicon/ChevronRightIcon'
import ChevronUpIcon from '@offerzen/zenicon/ChevronUpIcon'
import ChevronDownIcon from '@offerzen/zenicon/ChevronDownIcon'
import CalendarIcon from '@offerzen/zenicon/CalendarIcon'
import { roundMinutesToStep } from '../../helpers/datetimeHelpers'
import { colors } from '../../themes'
import Button from '../Button'
import FormErrorMessage from '../FormErrorMessage'
import FormHelpText from '../FormHelpText'
import AccessibleIcon from '../AccessibleIcon'
import PickerToggle from './PickerToggle'
import styles, { wrapperTheme, labelTheme, dayTheme } from './styles'

class DateTimePicker extends Component {
  state = {
    open: false,
    activeMonth: null,
    activeDate: null,
    selecting: 'date',
  }

  componentDidMount() {
    const { input, minDate, maxDate, minuteStep, onChange, ...props } = this.props
    const value = input.value || props.value
    const date = value ? new Date(value) : new Date()
    let activeDate = roundMinutesToStep(date, minuteStep)

    if (minDate || maxDate) {
      // If supplied date is out of range, adjust and push the change
      activeDate = this.adjustDateToRange(activeDate)

      // Make sure to push the new initial date, if there was any to begin with
      const handler = input.onChange || onChange
      if (value && handler) handler(activeDate)
    }

    this.setState({ activeMonth: activeDate, activeDate })
  }

  adjustDateToRange = date => {
    const { minDate, minuteStep, maxDate } = this.props
    let newDate = date

    if (minDate && isBefore(date, minDate)) {
      // Add half the minute step to ensure it will round above the min date, not below
      newDate = addMinutes(minDate, minuteStep / 2)
    }

    if (maxDate && isAfter(date, maxDate)) {
      // Substract half the minute step to ensure it will round below the max date, not above
      newDate = addMinutes(maxDate, -minuteStep / 2)
    }

    return roundMinutesToStep(newDate, minuteStep)
  }

  selectDate = date => {
    const { activeDate } = this.state
    const { input, onChange } = this.props

    const newDate = this.adjustDateToRange(setHours(setMinutes(date, getMinutes(activeDate)), getHours(activeDate)))
    this.setState({ activeDate: newDate, activeMonth: newDate })

    const handler = input.onChange || onChange
    if (handler) handler(newDate)
  }

  selectTime = time => {
    const { activeDate } = this.state
    const { input, onChange } = this.props

    const newTime = this.adjustDateToRange(setYear(setMonth(setDate(time, getDate(activeDate)), getMonth(activeDate)), getYear(activeDate)))
    this.setState({ activeDate: newTime, activeMonth: newTime })

    const handler = input.onChange || onChange
    if (handler) handler(newTime)
  }

  closePicker = ev => {
    this.setState({ open: false, selecting: 'date' })

    const handler = this.props.input.onBlur || this.props.onBlur
    if (handler) handler(ev)
  }

  render() {
    const { open, activeMonth, activeDate, selecting } = this.state
    const { meta, input, theme, className, helpText, tabIndex, readOnly, minuteStep, ...props } = this.props

    const name = input.name || props.name
    const errored = meta.touched && meta.error

    const value = input.value || props.value
    const formatter = props.formatter || format
    const formattedValue = isValid(new Date(value)) ? formatter(roundMinutesToStep(value, minuteStep), 'YYYY-MM-DD HH:mm') : ''

    const firstOfMonth = startOfMonth(activeMonth)
    const prevMonthDays = getDay(firstOfMonth)
    const firstDayInCalendar = addDays(firstOfMonth, -prevMonthDays)

    const weeks = new Array(differenceInCalendarWeeks(addMonths(firstOfMonth, 1), firstOfMonth) + 1).fill(new Array(7).fill(0))
    const calendarWeeks = weeks.map((week, weekIndex) =>
      week.map((_, dayInWeek) => {
        const date = addWeeks(addDays(firstDayInCalendar, dayInWeek), weekIndex)
        const beforeMinDate = props.minDate ? isBefore(startOfDay(date), startOfDay(props.minDate)) : false
        const afterMaxDate = props.maxDate ? isAfter(endOfDay(date), endOfDay(props.maxDate)) : false

        return {
          day: format(date, 'D'),
          selected: isEqual(startOfDay(activeDate), startOfDay(date)) && !!value,
          inMonth: isSameMonth(activeMonth, date),
          disabled: beforeMinDate || afterMaxDate,
          ...(!beforeMinDate &&
            !afterMaxDate && {
              onClick: () => {
                this.selectDate(date)
                this.setState({ selecting: 'time' })
              },
            }),
        }
      }),
    )

    return (
      <div className={cx(styles.wrapper, className, wrapperTheme(theme), errored && styles.wrapperError)}>
        {/* Render body first so the "input" appears on top */}
        {Boolean(open) && (
          <>
            <div className={styles.body} tabIndex="-1">
              {Boolean(selecting === 'date') && (
                <>
                  <PickerToggle
                    theme={theme}
                    mode="date"
                    selectMode={mode => {
                      this.setState({ selecting: mode })
                      if (this.input) this.input.focus()
                    }}
                  />
                  <div className={styles.calendarHeader}>
                    <div className={styles.calendarNavigation} onClick={() => this.setState({ activeMonth: addMonths(activeMonth, -1) })}>
                      <AccessibleIcon icon={ChevronLeftIcon} size={20} color={colors.grayChateau} />
                    </div>

                    <strong>{format(activeMonth, 'MMMM YYYY')}</strong>

                    <div className={styles.calendarNavigation} onClick={() => this.setState({ activeMonth: addMonths(activeMonth, 1) })}>
                      <AccessibleIcon icon={ChevronRightIcon} size={20} color={colors.grayChateau} />
                    </div>
                  </div>
                  <table className={styles.calendar}>
                    <thead>
                      <tr>
                        <th>Su</th>
                        <th>Mo</th>
                        <th>Tu</th>
                        <th>We</th>
                        <th>Th</th>
                        <th>Fr</th>
                        <th>Sa</th>
                      </tr>
                    </thead>

                    <tbody>
                      {calendarWeeks.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {row.map((cell, cellIndex) => (
                            <td
                              key={cellIndex}
                              className={cx(styles.day, cell.disabled && styles.dayDisabled, !cell.inMonth && styles.dayOut)}>
                              {/* TODO: refactor as buttons with optional disabled state */}
                              <span
                                className={cx(
                                  styles.dayWrapper,
                                  !cell.inMonth && styles.dayWrapperOut,
                                  cell.selected && dayTheme(theme, cell.inMonth),
                                )}
                                onClick={cell.onClick}>
                                {cell.day}
                              </span>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className={styles.footer}>
                    <Button theme={theme} size="small" label="Today" variant="outlined" onClick={() => this.selectDate(new Date())} />
                    <Button theme={theme} size="small" label="Done" onClick={() => this.closePicker()} />
                  </div>
                </>
              )}

              {Boolean(selecting === 'time') && (
                <>
                  <PickerToggle
                    theme={theme}
                    mode="time"
                    selectMode={mode => {
                      this.setState({ selecting: mode })
                      if (this.input) this.input.focus()
                    }}
                  />
                  <div className={styles.clock}>
                    <table>
                      <tbody>
                        <tr>
                          <td className={styles.timeNavigation}>
                            {/* TODO: refactor as buttons */}
                            <div
                              className={styles.timeNavigationWrapper}
                              onClick={() => this.selectTime(addHours(activeDate, 1))}
                              aria-label="increase by 1 hour">
                              <AccessibleIcon icon={ChevronUpIcon} size={22} color={colors.grayChateau} />
                            </div>
                          </td>
                          <td />
                          <td className={styles.timeNavigation}>
                            <div
                              className={styles.timeNavigationWrapper}
                              onClick={() => this.selectTime(addMinutes(activeDate, minuteStep))}
                              aria-label="increase by 15 minutes">
                              <AccessibleIcon icon={ChevronUpIcon} size={22} color={colors.grayChateau} />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.time}>{format(activeDate, 'HH')}</td>
                          <td className={styles.timeDivider}>:</td>
                          <td className={styles.time}>{format(activeDate, 'mm')}</td>
                        </tr>
                        <tr>
                          <td className={styles.timeNavigation}>
                            <div
                              className={styles.timeNavigationWrapper}
                              onClick={() => this.selectTime(addHours(activeDate, -1))}
                              aria-label="reduce by 1 hour">
                              <AccessibleIcon icon={ChevronDownIcon} size={22} color={colors.grayChateau} />
                            </div>
                          </td>
                          <td />
                          <td className={styles.timeNavigation}>
                            <div
                              className={styles.timeNavigationWrapper}
                              onClick={() => this.selectTime(addMinutes(activeDate, -minuteStep))}
                              aria-label="reduce by 15 minutes">
                              <AccessibleIcon icon={ChevronDownIcon} size={22} color={colors.grayChateau} />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className={styles.footer}>
                    <Button
                      theme={theme}
                      size="small"
                      label="Now"
                      variant="outlined"
                      onClick={() => this.selectTime(roundMinutesToStep(new Date(), minuteStep))}
                    />
                    <Button theme={theme} size="small" label="Done" onClick={() => this.closePicker()} />
                  </div>
                </>
              )}
            </div>
            <div className={styles.overlay} onClick={this.closePicker} />
          </>
        )}
        <div
          className={cx(styles.label, labelTheme(theme), open && styles.openLabel, errored && styles.errorLabel)}
          tabIndex={tabIndex}
          readOnly={readOnly}
          onClick={ev => {
            if (open) {
              this.closePicker()
              return
            }

            this.setState({ open: true })

            const focusHandler = input.onFocus || props.onFocus
            if (focusHandler) focusHandler(ev)
          }}>
          <input
            {...input}
            type="text"
            className={styles.input}
            tabIndex="-1"
            readOnly
            id={props.id}
            // eslint-disable-next-line no-return-assign
            ref={el => (this.input = el)}
            name={name}
            value={formattedValue}
            placeholder={props.placeholder}
            onBlur={ev => ev.preventDefault()}
          />

          <div className={styles.icon}>
            <AccessibleIcon icon={CalendarIcon} size={18} color={errored ? colors.mandy : colors.geyser} />
          </div>
        </div>
        {Boolean(helpText && !errored) && <FormHelpText text={helpText} />}
        {Boolean(errored) && <FormErrorMessage text={meta.error} />}
      </div>
    )
  }
}

DateTimePicker.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    name: PropTypes.string,
  }),
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  tabIndex: PropTypes.string,
  readOnly: PropTypes.bool,
  helpText: PropTypes.string,
  formatter: PropTypes.func,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  minuteStep: PropTypes.number,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  id: PropTypes.string,
}

DateTimePicker.defaultProps = {
  meta: {},
  input: {},
  name: '',
  value: '',
  tabIndex: '0',
  theme: 'primary',
  minuteStep: 15,
}

export default DateTimePicker
